import * as React from 'react'
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { MdSpeed, MdTimer } from 'react-icons/md'
import { IBelimoEnergyValve } from './types'

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from 'baseui/select';
import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { EnergyValveControlMode } from './EnergyValveControlMode';
import { EnergyValveState } from './EnergyValveState';

export const ConfigurationPanel = (props: IBelimoEnergyValve) => {
    const intl = useIntl();
    const [errDelay, setErrDelay, setErrDelayResult] = useSetObjectValue(props.id, props.resourceGroupId, "errDelay", props.errDelay);
    const onValueChanged = (e: any) => setErrDelay(parseFloat(e.target.value));

    const [setpointAbsoluteFlow, setSetpointAbsoluteFlow, setSetpointAbsoluteFlowResult] = useSetObjectValue(props.id, props.resourceGroupId, "setpointAbsoluteFlow", props.setpointAbsoluteFlow);
    const onSetpointAbsoluteFlowChanged = (e: any) => setSetpointAbsoluteFlow(parseFloat(e.target.value));


    const [eVMode, setEVMode] = useSetObjectValue(props.id, props.resourceGroupId, "eVMode", props.eVMode);
    const onEVModeChanged = (e: any) => {
        setEVMode(e.value[0].id);
    }

    const controlModes = Object.keys(EnergyValveControlMode).filter((item) => {
        return isNaN(Number(item));
    });
    const b2 = controlModes.map((item: any, index: number) => { return { label: item, id: index } });

    return (
        <>

            
            <ValueDisplayWithLabel small label={<FormattedMessage id="Devices.State" defaultMessage="State" />} value=
                {props.eVState === EnergyValveState.Ok ? intl.formatMessage({ id: "Devices.OK", defaultMessage: "OK" }) :
                    props.eVState === EnergyValveState.Warning ? intl.formatMessage({ id: "Devices.Warning", defaultMessage: "Warning" }) :
                        intl.formatMessage({ id: "Devices.ERROR", defaultMessage: "ERROR" })} dimension={""}></ValueDisplayWithLabel>

<FormControl
                label={<FormattedMessage id="Devices.SetpointAbsoluteFlow" defaultMessage="Setpoint Absolute Flow" />}
                error={setSetpointAbsoluteFlowResult.isError}
                disabled={setSetpointAbsoluteFlowResult.isLoading}
            >
                <Input
                    value={setpointAbsoluteFlow?.toFixed(0)}
                    onChange={onSetpointAbsoluteFlowChanged}
                    type='number'
                    endEnhancer={props.dimensionFlow}
                    startEnhancer={<MdSpeed></MdSpeed>}
                />
            </FormControl>
            <FormControl
                label={<FormattedMessage id="Devices.ControlMode" defaultMessage="Control Mode" />}
                caption={<FormattedMessage id="Devices.TextControlMode" defaultMessage="Enter the control mode of the valve" />}
            >
                <Select
                    options={b2}
                    value={eVMode}
                    required
                    placeholder={
                        props.eVMode === EnergyValveControlMode.FlowControl ? <FormattedMessage id="Devices.FlowControl" defaultMessage="Flow Control" /> :
                            props.eVMode === EnergyValveControlMode.PositionControl ? <FormattedMessage id="Devices.PositionControl" defaultMessage="Position Control" /> :
                                <FormattedMessage id="Devices.PowerControl" defaultMessage="Power Control" />}
                    onChange={onEVModeChanged}
                />

            </FormControl>
        </>
    )
}
